import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import Visibility from "@material-ui/icons/Visibility";
import Buttons from "components/buttons/Pressed";
import { useStyles } from "components/layout/CommonStyles";
import ProjectsContext from "context/projects/projectsContext";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import CloseIcon from '@material-ui/icons/Close';
import Cookies from "js-cookie";

const ExpensesTableActions = props => {
    const classes = useStyles();
    const [t] = useTranslation();
    const { projectId, id, mode, expenseName, expense, openDialog, setOpenDialog, allAllowances } = props;
    const [openDelete, setOpenDelete] = useState(false);
    const [dialogMode, setDialogMode] = useState(t("GENERAL.viewMode"));
    const projectsContext = useContext(ProjectsContext);
    const { deleteExpense, response, responseType, setDialogData } = projectsContext;

    // const handleClickOpen = (type) => {
    //     setDialogData(expense, type, true);
    // };

    const handleClickOpenDelete = () => {
        setOpenDelete(true);
    };

    const getPermission = (screen, allowance) => {
        for (let i = 0; i < allAllowances.length; i++) {
            if (allAllowances[i].resource === screen) {
                return allAllowances[i]["standardauthorizationoption"][allowance]
            }
        }
    }

    const handleEdit = () => {
        axios.get(process.env.REACT_APP_SERVER + `api/expenses/edit/${id}`, {
            headers: {
                "Content-type": "application/json",
                "Authorization": "bearer " + (Cookies.get('auth-token') ? Cookies.get('auth-token') : "")
            }
        })
            .then(res => {
                if (res.statusText === "OK") {
                    setDialogData(expense, t("GENERAL.editMode"), true);
                } else {
                    deleteExpense(id);
                }
            })
            .catch(error => {
                deleteExpense(id);
            });
    };

    const handleView = () => {
        axios.get(process.env.REACT_APP_SERVER + `api/expenses/edit/${id}`, {
            headers: {
                "Content-type": "application/json",
                "Authorization": "bearer " + (Cookies.get('auth-token') ? Cookies.get('auth-token') : "")
            }
        })
            .then(res => {
                if (res.statusText === "OK") {
                    setDialogData(expense, t("GENERAL.viewMode"), true);
                } else {
                    deleteExpense(id);
                }
            })
            .catch(error => {
                deleteExpense(id);
            });
    };

    const handleClose = () => {
        setOpenDelete(false);
    };

    const handleDelete = () => {
        deleteExpense(id);
        setOpenDelete(false);
    };

    return (
        <div>
            {allAllowances.length > 0 && getPermission("PHASES", "allowRead") &&
                <Tooltip title="Visualizar" aria-label="details" placement="top">
                    <IconButton className={classes.actionsIcons} onClick={handleView}>
                        <Visibility />
                    </IconButton>
                </Tooltip>
            }
            {mode === "edit" && allAllowances.length > 0 && getPermission("EXPENSES", "allowUpdate") &&
                <Tooltip title="Editar" aria-label="edit" placement="top">
                    <IconButton className={classes.actionsIcons} onClick={handleEdit}>
                        <Edit />
                    </IconButton>
                </Tooltip>
            }
            {mode === "edit" && allAllowances.length > 0 && getPermission("PHASES", "allowDelete") &&
                <Tooltip title="Deletar" aria-label="delete" placement="top">
                    <IconButton className={classes.actionsIcons} onClick={handleClickOpenDelete}>
                        <Delete />
                    </IconButton>
                </Tooltip>
            }
            {/* Dialog Delete Expense */}
            <Dialog
                open={openDelete}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                msg="mensagem"
            >
                <DialogTitle className={classes.actionsTitle}>
                    {t("GENERAL.notification")}
                    <IconButton style={{ float: "right", marginTop: -10, marginRight: -17 }} edge="end" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {`Você deseja realmente deletar a despesa "${expenseName}"?`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Buttons
                        onClick={handleClose}
                        tipo="BN-noback"
                        conteudo={t("GENERAL.cancel")}
                    />
                    <Buttons
                        onClick={handleDelete}
                        tipo="BN-blue"
                        conteudo={t("GENERAL.delete")}
                    />
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ExpensesTableActions;